'use client';

import Link from 'next/link';
import { trackSectionCta } from '@/components/GoogleAnalytics';

export default function HomeAboutSection() {
  return (
    <section className="bg-[linear-gradient(180deg,#FFF0F6_0%,#F0F0FF_100%)] py-16 md:py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            About Marathi Vadhu Var Suchak Mandal
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A most trusted and safe Marathi matrimony platform. Choose a life partner according to your preferences from various Marathi community matrimony profiles. We have advanced search options and personalized suggestions that make finding your partner easy and quick. Register free today and turn your Marathi wedding dreams into reality!
            <br />
            <span className="font-bold">मराठी वधू वर सूचक मंडळ</span>
          </p>
          <Link
            href="/about"
            onClick={() => trackSectionCta('click_read_about', 'about_section', 'Read more About Us')}
            className="mt-8 inline-flex items-center justify-center rounded-full border border-primary-600 px-8 py-3.5 text-[16px] font-semibold text-primary-600 transition-colors hover:bg-primary-600 hover:text-white"
          >
            Read more About Us
          </Link>
        </div>
      </div>
    </section>
  );
}
